import { useLayoutEffect, useState } from "react"

export default function Legend({ chart, series, seriesType, instrument }) {
    /* Legend for charts data, displays all relevant candle info in the left top corner */
    const [legendData, setLegendData] = useState({});

    function handleSubscribeCrosshairMove(param) {
        /*Update the legend if hovering over a candle */
        if (param.time) {
            const data = param.seriesData.get(series.current);
            setLegendData(data);
        } else {
            setLegendData({});
        }
    }

    useLayoutEffect(() => {
        const updateLegend = async () => {
            while (!chart.current) {
                await new Promise(resolve => setTimeout(resolve, 100));
            }
            chart.current.subscribeCrosshairMove(handleSubscribeCrosshairMove);
        };
        updateLegend();
    }, [chart])

    const styles = {
        position: 'absolute',
        top: '30px',
        left: '50px',
        zIndex: 20,
        color: 'white'
    }
    const currency = instrument.name.slice(-3);
    if (seriesType === 'candlestick' || seriesType === 'bar') {
        return (
            <div style={styles}>
                {legendData?.open ? (
                    <>
                        <p>HIGH: {legendData.high} {currency}</p>
                        <p>OPEN: {legendData.open} {currency}</p>
                        <p>CLOSE: {legendData.close} {currency}</p>
                        <p>LOW: {legendData.low} {currency}</p>
                    </>
                ) : null}
            </div>
        )
    }
    return (
        <div style={styles}>
            {legendData?.value ? (
                <>
                    <p>VALUE: {legendData.value} {currency}</p>
                </>
            ) : null}
        </div>
    )
}